module.exports = __webpack_public_path__ + "img/AlarmaManual.6b48dec0.svg";